<template>
  <section class="business-payment">
    <v-button
      class="btn-cancel"
      @click="handlerCancel">Cancel</v-button>
    <div class="payment-container">
      <h1>{{ isAddRecord? 'Add Payment Record': 'Set Payment Record' }}</h1>
      <!-- <new-payment-form
        type="business"
        :customerId="customerId"
        :customerName="customer.isrd_nm"
        :amount="amountResult"
        :orderId="orderId"
        @success="paymentSuccess"
      /> -->
      <v-checkbox
        v-model="isUseCredits">Use Hold Dollars</v-checkbox>
      <div
        class="credit-box"
        :class="{ 'mask-container': !isUseCredits }">
        <div class="flex-sb">
          <div class="form-item">
            <span>
              Balance
              <span class="name">{{ customer.isrd_nm }}</span>
            </span>
            <span class="amount">{{ money | formatMoney(2, true) }}</span>
          </div>
          <div class="input-box">
            <v-input
              v-model.number="credit"
              prepend="$" />
          </div>
        </div>
      </div>

      <div class="payment-form">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div
            v-if="isAddRecord"
            class="form-item">
            <el-form-item>
              <span class="label">Action</span>
              <div class="form-input">
                <v-select
                  v-model="formData.action"
                  :list="actionList"
                />
              </div>
            </el-form-item>
          </div>
          <div
            class="form-item">
            <el-form-item
              ref="pay_type"
              prop="pay_type">
              <span class="label">Method</span>
              <div class="form-input">
                <v-select
                  v-model="formData.pay_type"
                  :list="payOptions"
                />
              </div>
            </el-form-item>
          </div>
          <div
            class="form-item ">
            <el-form-item
              ref="date"
              prop="date">
              <span class="label">Date</span>
              <div class="form-input">
                <v-date-picker
                  v-model="formData.date"
                />
              </div>
            </el-form-item>
          </div>
          <div
            class="form-item ">
            <el-form-item
              ref="amount"
              prop="amount">
              <span class="label">Amount</span>
              <div class="form-input">
                <v-input
                  v-model="formData.amount"
                  prepend="HK$"
                  :keyNonChinese="true"
                />
              </div>
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span class="label">Reference No.</span>
            <div class="form-input">
              <v-input
                v-model="formData.reference_no"
              />
            </div>
          </div>
          <div class="form-item">
            <span>Proof</span>
            <v-upload
              :card="true"
              :fileData="formData.proof_file_id_pic"
              :otherData="{
                target: 'proof_file_id_pic',
                idKey: 'proof_file_id',
                nameKey: 'proof_file_id_path'
              }"
              @uploadSuccess="handlerUploadSuccess"
              @delete="handlerUploadDelete"
            />
          </div>
          <div
            class="form-item ">
            <span class="label">Remarks</span>
            <div class="form-input">
              <v-input
                v-model="formData.remark"
                type="textarea"
                :rows="4"
              />
            </div>
          </div>
        </el-form>
        <div>
          <v-button
            type="success"
            @click="handlerNext">
            {{ isAddRecord? 'Done': 'Next' }}
          </v-button>
          <v-button
            v-if="!isAddRecord"
            @click="handlerSkip">Skip</v-button>
        </div>
      </div>

    </div>
    <div
      v-if="!isAddRecord"
      class="info-container">
      <div class="company-logo">
        <img
          :src="policyDetail.company_logo"
          alt="company" />
        <span class="label">{{ policyDetail.plan }}</span>
      </div>
      <div class="flex-box">
        <div class="flex-info">
          <span>Basic Premium</span>
          <span>{{ premiumData.basic_prm | formatMoney(2, true) }}</span>
        </div>
        <div class="flex-info">
          <span>EC Levy</span>
          <span>{{ premiumData.ec_levy_vl | formatMoney(2, true) }}</span>
        </div>
        <div class="flex-info">
          <span>IA Levy</span>
          <span>{{ premiumData.ia_levy_vl | formatMoney(2, true) }}</span>
        </div>
        <div class="flex-info">
          <span>Premium</span>
          <span>{{ premiumData.premium | formatMoney(2, true) }}</span>
        </div>
        <div
          v-if="premiumData.code_disc_prm"
          class="flex-info">
          <!--          <span>MGM Discount {{ premiumData.code_disc_pct }}%</span>-->
          <span>MGM Discount</span>
          <span>{{ -premiumData.code_disc_prm | formatMoney(2, true) }}</span>
        </div>
        <div
          v-if="premiumData.coupon_code"
          class="flex-info">
          <span>Coupon: {{ premiumData.coupon_code }}</span>
          <span>{{ -premiumData.coupon_vl | formatMoney(2, true) }}</span>
        </div>
        <div class="flex-info">
          <span>Manual Discount</span>
          <span>{{ -premiumData.spec_disc_prm | formatMoney(2, true) }}</span>
        </div>
        <div class="flex-info">
          <span>Admin Charge</span>
          <span>{{ premiumData.handling_fee | formatMoney(2, true) }}</span>
        </div>
        <div
          v-if="isUseCredits"
          class="flex-info">
          <span>Hold Dollars</span>
          <span>{{ -credit | formatMoney(2, true) }}</span>
        </div>
        <div class="flex-info total-amount">
          <span>Paid Amount</span>
          <span>{{ amountResult | formatMoney(2, true) }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinFormat from '@/mixins/format'
import MixinOption from '@/mixins/options'
import MixinRules from '@/mixins/rules'
// import newPaymentForm from '@/views/components/newPaymentForm'
import { getManualPolicyDetail } from '@/api/policy'
import { getAccountClientWallet } from '@/api/account'
import { paymentForSme, generateManualPolicy } from '@/api/ticket'

export default {
  name: 'BusinessPayment',
  components: {
    // newPaymentForm,
  },
  mixins: [MixinFormat, MixinOption, MixinRules],
  props: {
    type: {
      type: String,
      default: ''
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
    customerId: {
      type: [String, Number],
      default: '',
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      policyDetail: {},
      money: '',
      isUseCredits: false,
      credit: '',
      formData: {
        action: '',
        pay_type: '',
        date: '',
        amount: '',
        reference_no: '',
        remark: '',
        proof_file_id: '',
        proof_file_id_pic: null
      },
      actionList:[
        {
          name: 'New Policy',
          id: 1
        },
        {
          name: 'Endorsment',
          id: 2
        }
      ],
    }
  },
  computed: {
    isAddRecord() {
      return this.type == 'addRecord'
    },
    premiumData() {
      return this.policyDetail.premium_data || {}
    },
    amountResult() {
      const { amount } = this.premiumData
      if(this.isUseCredits) {
        return Number(amount) - Number(this.credit)
      }
      return Number(amount)
    },
  },
  watch: {
    orderId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.network().getManualPolicyDetail()
        }
      },
    },
    customerId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.network().getAccountClientWallet()
        }
      }
    }
  },
  methods: {
    handlerSkip() {
      this.network().generateManualPolicy()
    },
    handlerNext() {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          this.network().paymentForSme()
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { id } = data
      this.$set(this.formData, 'proof_file_id_pic', data)
      this.$set(this.formData, 'proof_file_id', id)
    },
    handlerUploadDelete({ data, result, otherData }) {
      this.$set(this.formData, 'proof_file_id_pic', null)
      this.$set(this.formData, 'proof_file_id', '')
    },
    handlerCancel() {
      this.$emit('cancel')
    },
    paymentSuccess() {
      this.$emit('business-payment-success')
    },
    network() {
      return {
        paymentForSme: async () => {
          let params = {
            order_id: this.orderId,
            ...this.formData
          }
          if(this.isUseCredits) {
            params.credit = this.credit
          }
          const { data } = await paymentForSme(params)
          this.paymentSuccess()
        },
        generateManualPolicy: async () => {
          const { data } = await generateManualPolicy({
            order_id: this.orderId
          })
          this.paymentSuccess()
        },
        getManualPolicyDetail: async () => {
          const { data } = await getManualPolicyDetail({
            order_id: this.orderId,
          })
          this.policyDetail = data
        },
        getAccountClientWallet: async () => {
          const { data } = await getAccountClientWallet({
            client_id: this.customerId
          })
          this.money = data.money
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.business-payment {
    position: relative;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 100px;
  width: 100%;
  .btn-cancel {
      position: absolute;
      top: 20px;
      right: 20px;
  }
  .payment-container {
    width: 500px;
    .credit-box {
    margin-left: 20px;
    margin-top: 5px;
    padding: 15px 15px 0 15px;
    background: #F6F8FA;
    border-radius: 4px;
    margin-bottom: 30px;
    .flex-sb {
      align-items: center;
    }
    .amount {
      color: #409EFF;
      font-size: 24px;
      font-weight: bold;
    }
    .input-box {
      margin-top: -10px;
      width: 130px;
    }
  }
  }
  .info-container {
    width: 280px;
    .company-logo {
      margin-top: 31px;
      display: flex;
      align-items: center;
      width: 280px;
      img {
        // width: 100%;
        //height: 100%;
        margin-right: 26px;
        margin-left: 11px;
        height: 51px;
      }
    }
    .flex-box {
      border-radius: 5px;
      border: 1px solid #e1e4e8;
      width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #e1e4e8;

        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
        }

        span:last-child {
          color: #24292e;
          font-size: 14px;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color {
        span {
          color: rgb(205, 43, 56) !important;
        }
      }

      .amount {
        color: #24292e;
        font-weight: bolder;
      }
    }
  }
}
</style>
